"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCampaignGenerator = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var interval_1 = require("./generators/interval");
var period_1 = require("./generators/period");
var exact_1 = require("./generators/exact");
var types_1 = require("./types");
var enums_1 = require("../../enums");
var intervalExact_1 = require("./generators/intervalExact");
function initializeAdGenerator(notExactCampaigns, timezone, pattern, cutDuration, addToSkipped, logger, tracing) {
    if (pattern === void 0) { pattern = enums_1.EGenerationPatterns.WITHOUT_MUSIC_CUT; }
    var generators = [];
    var IntervalGenerator = pattern === enums_1.EGenerationPatterns.WITH_MUSIC_CUT
        ? intervalExact_1.AdCampaignIntervalExactGenerator
        : interval_1.AdCampaignIntervalGenerator;
    notExactCampaigns.forEach(function (adCampaign) {
        switch (adCampaign.type) {
            case "interval":
                generators.push(new IntervalGenerator(adCampaign, timezone, logger, tracing, cutDuration, addToSkipped));
                break;
            case "period":
                generators.push(new period_1.AdCampaignPeriodGenerator(adCampaign, timezone, logger, tracing));
                break;
        }
    });
    return generators;
}
var AdCampaignGenerator = (function () {
    function AdCampaignGenerator(_a) {
        var adCampaigns = _a.adCampaigns, timezone = _a.timezone, startTime = _a.startTime, logger = _a.logger, tracing = _a.tracing, pattern = _a.pattern, cutDuration = _a.cutDuration;
        this.generators = [];
        this.skipped = { byId: {}, total: 0 };
        this.adCampaigns = adCampaigns;
        this.timezone = timezone;
        this.pattern = pattern;
        this.cutDuration = cutDuration;
        if (typeof startTime === "string" && startTime.endsWith("Z")) {
            this.startTime = (0, moment_timezone_1.default)(startTime).utc(false).tz(moment_timezone_1.default.tz.guess(), true).tz(timezone);
        }
        else {
            this.startTime = (0, moment_timezone_1.default)(startTime).tz(timezone);
        }
        this.initializeGenerators();
        this.logger = logger;
        this.tracing = tracing;
    }
    Object.defineProperty(AdCampaignGenerator.prototype, "skippedPromos", {
        get: function () {
            return this.skipped;
        },
        enumerable: false,
        configurable: true
    });
    AdCampaignGenerator.prototype.addToSkipped = function (promo) {
        if (!promo.adcompanyId)
            return;
        if (!this.skipped.byId[promo.adcompanyId]) {
            this.skipped.byId[promo.adcompanyId] = [];
        }
        this.skipped.total += 1;
        this.skipped.byId[promo.adcompanyId].push(promo);
    };
    AdCampaignGenerator.prototype.sortGenerators = function () {
        this.generators.sort(function (a, b) {
            var _a, _b;
            var aTarget = ((_a = a === null || a === void 0 ? void 0 : a.getTargetTime()) === null || _a === void 0 ? void 0 : _a.valueOf()) || 0;
            var bTarget = ((_b = b.getTargetTime()) === null || _b === void 0 ? void 0 : _b.valueOf()) || 0;
            if (aTarget === bTarget) {
                return a.getId() - b.getId();
            }
            return aTarget > bTarget ? 1 : -1;
        });
    };
    AdCampaignGenerator.prototype.initializeGenerators = function () {
        var exactCampaigns = [];
        var notExactCampaigns = [];
        this.adCampaigns.forEach(function (adCampaign) {
            adCampaign.type === "exact_time"
                ? exactCampaigns.push(adCampaign)
                : notExactCampaigns.push(adCampaign);
        });
        this.generators = initializeAdGenerator(notExactCampaigns, this.timezone, this.pattern, this.cutDuration, this.addToSkipped.bind(this));
        if (exactCampaigns.length) {
            var exactAggregator = new exact_1.AdCampaignExactAggregator(exactCampaigns, this.startTime, this.timezone);
            this.generators.unshift(exactAggregator);
        }
    };
    AdCampaignGenerator.prototype.generate = function (context) {
        var e_1, _a;
        while (true) {
            var allGeneratorsFailed = true;
            if (this.pattern === enums_1.EGenerationPatterns.WITH_MUSIC_CUT) {
                this.sortGenerators();
            }
            try {
                for (var _b = (e_1 = void 0, __values(this.generators)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var gen = _c.value;
                    if (context.reachedTargetLength()) {
                        break;
                    }
                    var result = gen.getRotation({
                        nextTime: context.getNextTime(),
                        rotations: context.resultRotations,
                        lastRotations: context.lastRotations,
                    });
                    if (result instanceof types_1.GetRotationError) {
                        context.revertRotation();
                        break;
                    }
                    if (result instanceof types_1.GetRotationResult) {
                        context.addRotation(result.rotation, result.nextTime);
                        allGeneratorsFailed = false;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (allGeneratorsFailed) {
                break;
            }
        }
    };
    return AdCampaignGenerator;
}());
exports.AdCampaignGenerator = AdCampaignGenerator;
//# sourceMappingURL=index.js.map